module.exports = __webpack_public_path__ + "img/ticon1.30b0ead0.png";